<template>
    <v-container id="homePageContainer" v-if="!loading">
        <v-row>
            <v-col cols="12" md="6" :class="getTextClass()">
                <div class="mainBannerText">
                    <div class="text-left">
                        <p class="mainText">{{ tl(getMainBannerData.title) }}</p>
                    </div>
                    <p class="subText">{{ tl(getMainBannerData.description) }}</p>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <div>
                    <v-img 
                        v-if="(new Date()).getUTCDate()%2!==0"
                        :src="getMainBannerData.image1"
                        contain
                        max-height="400"
                        transition="scale-transition"
                    ></v-img>
                    <v-img 
                        v-else
                        :src="getMainBannerData.image2"
                        contain
                        max-height="400"
                        transition="scale-transition"
                    ></v-img>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "MainBanner",
    computed: {
        ...mapGetters(["getMainBannerData", "loading", "getWindowWidth"])
    },
    methods: {
        getTextClass() {
            if (this.getWindowWidth<960) {
                return "colSm";
            } else if (this.getWindowWidth < 1250) {
                return "coldMd";
            } else {
                return "colLg";
            }
        }
    }
}
</script>

<style scoped>
#homePageContainer {
    padding-top: 0;
    padding-bottom: 0;
}
.mainBannerText {
    margin-top: 5%;
    margin-bottom: auto;
    width: 85%;
}
.subText {
    font-size: 1.8em;
}
.mainText {
    font-size: 3.8em;
}
.colLg {
    padding-left: 100px;
}
.colMd {
    padding-left: 10px;
}
.colSm {
    padding-left: 30px;
}
</style>